import React from 'react';

import {AnalysisFlowchartAction} from 'analysis-tool/flowchart/actions/AnalysisFlowchartActionTypes';
import {useAnalysisFlowchartContext} from 'analysis-tool/flowchart/AnalysisFlowchartContext';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export default function AddSourceStepButton(): JSX.Element | null {
  const config = useAnalysisFlowchartContext();
  const {enabled, doAction, message} = config.getActionInfo(AnalysisFlowchartAction.OPEN_ADD_SOURCE_STEP);

  if (!enabled && !message) {
    return null;
  }

  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      size={ButtonSize.MEDIUM}
      text="Add source step"
      onClick={() => {
        if (doAction) {
          doAction();
        }
      }}
      disabled={!enabled}
    />
  );
}
